module.exports = __webpack_public_path__ + "static/media/ha.47b7a5ad.png";